export const POSTS = [
  {
    slug: "what-are-skill-games",
    aliases: ["skill-games-for-cash"],
    title: "What Are Skill Games? A Beginner's Guide",
    date: "2026-06-01",
    excerpt: "Skill games reward your ability, not luck. Here's how duels and tournaments work on PhonePlay.",
    body: [
      { p: "Skill games are contests where the outcome is decided by your ability — speed, accuracy, memory and timing — rather than random chance. On PhonePlay, you use free Fun Coins to join a 1v1 skill duel or an online skill tournament, and the best-performing players top the leaderboard and take the Fun Coin pool." },
      { h: "How skill games differ from chance games" },
      { p: "In a chance game like a slot machine, the result is random. In a skill game, two players face the same challenge and the higher score wins — so practice and focus genuinely improve your results. PhonePlay scores every skill game on its servers to keep things fair." },
      { h: "Popular skill games on PhonePlay" },
      { p: "Speed Math tests fast arithmetic, Reaction Rush measures reflexes, Memory Matrix challenges recall, and Solitaire Sprint and WordVolt blend familiar card and word play with pure skill mechanics — no random payouts." },
      { h: "Is it fair?" },
      { p: "Yes. Challenges are generated and scored server-side, opponents are matched by skill rating, and duels are played against real people only — never bots. Arcade chance games and skill games never mix." },
    ],
  },
  {
    slug: "fun-coins-vs-skill-arena",
    aliases: ["fun-coins-vs-cash"],
    title: "Fun Coins vs Skill Arena: How PhonePlay Works",
    date: "2026-06-02",
    excerpt: "PhonePlay has two clearly separated modes. Learn the difference between the free Fun Coin arcade and head-to-head skill games.",
    body: [
      { p: "PhonePlay is built around one simple rule: chance games are played with Fun Coins only, and competitive contests are always skill-based. This keeps the experience clear, safe and legal." },
      { h: "PhonePlay Arcade — free Fun Coin arcade" },
      { p: "Slots, wheel, plinko, crash, mines and table games in the PhonePlay Arcade are played with fun coins. Fun coins are non-redeemable — they have no monetary value and can't be exchanged for money. They're purely for entertainment, and you earn more every day with the daily bonus, quests and referrals." },
      { h: "Skill Arena — contests decided by skill" },
      { p: "Skill tournaments and 1v1 duels put you against a real opponent on the same puzzle or deal. Because outcomes are decided by skill, these are contests, not wagers on chance." },
      { h: "Why the separation matters" },
      { p: "Keeping the Fun Coin arcade and the Skill Arena completely separate protects players and keeps PhonePlay clear and fair. You'll always know which mode you're in." },
    ],
  },
  {
    slug: "win-skill-duels",
    title: "5 Tips to Win 1v1 Skill Duels on PhonePlay",
    date: "2026-06-03",
    excerpt: "Want to win more 1v1 skill duels? These five tips will sharpen your game across Speed Math, WordVolt, Solitaire Sprint and more.",
    body: [
      { p: "1v1 skill duels are fast, head-to-head contests played for Fun Coins and ELO rating. Here's how to give yourself the edge." },
      { h: "1. Practice for free first" },
      { p: "Use PhonePlay's free Practice Mode to learn a game's rhythm with nothing at stake before you enter a ranked duel." },
      { h: "2. Master one game" },
      { p: "Rather than dabbling, pick one skill game — say Card 21 or Precision Wheel — and get consistently fast and accurate at it." },
      { h: "3. Prioritise accuracy, then speed" },
      { p: "Most skill games reward correct answers per round. Lock in clean solutions before pushing your pace." },
      { h: "4. Warm up" },
      { p: "A couple of practice rounds right before a duel gets your reflexes and focus ready." },
      { h: "5. Play responsibly" },
      { p: "Take breaks, use the cooldown tools if you need them, and remember Fun Coins have no monetary value. Skill improves over time — play the long game." },
    ],
  },
];

export const getPost = (slug) => POSTS.find((p) => p.slug === slug || (p.aliases || []).includes(slug));
